import { Box, Stack, type SxProps } from "@mui/material";
import { Divider, Illustration } from "@src/appV2/redesign/system/ui-components";
import { Text, type TextProps } from "@src/appV2/redesign/system/ui-components";

interface Props {
  items: Array<
    {
      text: string;
    } & TextProps
  >;
  sx?: SxProps;
}

export function OrientationListItems(props: Props) {
  const { items, sx } = props;

  return (
    <Stack sx={sx}>
      <Stack direction="row" alignItems="center" gap={4}>
        <Box>
          <Illustration type="calendar-alert-small" />
        </Box>
        <Divider sx={{ flexGrow: 1 }} />
      </Stack>

      <Stack
        sx={{
          p: 6,
        }}
        spacing={6}
      >
        {items.map((item) => {
          const { text, ...rest } = item;

          return (
            <Stack key={text} direction="row" alignItems="flex-start" spacing={6}>
              <Box>
                <Box
                  width={8}
                  height={8}
                  sx={() => ({
                    transform: "rotate(45deg)",
                    backgroundColor: "#1C69D3",
                  })}
                  mt={1}
                />
              </Box>

              <Text {...rest} variant="body1">
                {text}
              </Text>
            </Stack>
          );
        })}
      </Stack>

      <Divider />
    </Stack>
  );
}
